import React from 'react';
import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router'
import { ToastContainer, Slide } from "react-toastify";

import 'react-toastify/dist/ReactToastify.css';
import Auth from './containers/Auth';
import Layout from './components/Layout';

const App = ({ history }) => (
  <ConnectedRouter history={history}>
    <React.Fragment>
      <Switch>
        <Route path='/' render={props => <Auth component={Layout} {...props} />} />
        <Route path='/login' component={Auth} />
      </Switch>
      <ToastContainer
        autoClose={2500}
        transition={Slide}
        position="top-center"
        hideProgressBar
        rtl
        closeButton={false}
      />
    </React.Fragment>
  </ConnectedRouter>
);

App.propTypes = {
  history: PropTypes.object,
}

export default App;